class ScenarioError extends Error {}

export default ScenarioError;
